import { FlowUnit } from '@app/shared/units/flow/flow-unit.enum';

export const flowFactors: Record<FlowUnit, number> = {
  [FlowUnit.LitresPerSecond]: 1,
  [FlowUnit.GallonsPerSecond]: 3.785411784,
};
